import { Component, OnInit } from '@angular/core';
import { advertisement, ServiceService } from '../service.service';
import {
  ActionSheetController,
  ToastController,
  Platform,
  LoadingController,
  AlertController,
  NavController
} from '@ionic/angular';
import {
  Camera,
  CameraOptions,
  PictureSourceType
} from '@ionic-native/Camera/ngx';
import { FilePath } from '@ionic-native/file-path/ngx';
import { finalize } from 'rxjs/operators';
import { File, FileEntry } from '@ionic-native/File/ngx';
import { WebView } from '@ionic-native/ionic-webview/ngx';
import { ChangeDetectorRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { allowedNodeEnvironmentFlags } from 'process';
import {Location} from '@angular/common';
import { Router } from '@angular/router';
import { UtilsService } from '../utils.service';
import { Crop } from '@ionic-native/crop/ngx';
import { FirebaseAnalytics } from '@ionic-native/firebase-analytics/ngx';
import { PointEarnedUser, RelUserBadges } from '../badges/badges-utils';

@Component({
  selector: 'app-actualizar-datos',
  templateUrl: './actualizar-datos.page.html',
  styleUrls: ['./actualizar-datos.page.scss' , '../../assets/scss/styles.scss'],
})

export class ActualizarDatosPage implements OnInit {
  
  userData: UserUpdate;
  catJobs: CatJob[];
  catForums: CatForum[];
  catMachines: CatMachine[];
  image: any;
  friendCode: any;
  isSelected:boolean=false;
  viewShowImag = '../../assets/images/userDefault.jpg';
  croppedImagepath = "";
  updateInfoUser: FormGroup;
  isMovil:boolean = false;
  advertisements:advertisement = new advertisement();

  constructor(
    private crop: Crop,
    public services: ServiceService,
    public alertController: AlertController,
    private loadingController: LoadingController,
    private platform: Platform,
    private toastController: ToastController,
    private actionSheetController: ActionSheetController,
    private camera: Camera,
    private file: File,
    private filePath: FilePath,
    private webview: WebView,
    private ref: ChangeDetectorRef,
    private http: HttpClient,
    private form: FormBuilder,
    private navCtrl: NavController,
    private _location: Location,
    private router: Router,
    public utils: UtilsService,
    private firebaseAnalytics: FirebaseAnalytics
  ) {
    // Init catalogs
    this.getCatJobs();
    this.getCatForums();
    this.getCatMachines();
    this.getInfoUser();
    this.firebaseAnalytics.logEvent;
    this.firebaseAnalytics.setCurrentScreen("Perfil");
  }

  async ngOnInit() {
  //  this.services.syncUp.subscribe( async () => {
  //   await this.getInfoUser();
  //  });
  this.isMovil = this.services.isMovil();
  if(this.services.isMovil()){
    this.isSelected = false;
  }else{
    this.isSelected= true;
  }
    this.friendCode = localStorage.getItem('friendCode') || '';
    if(!this.isMovil){
      this.advertisements = await this.services.getAdvertisementByScreen(9);
      this.advertisements.Displayed = this.advertisements.MediaBasico.slice(0,this.advertisements.Rows);
      this.advertisements.Random = this.services.NumberRandom(this.advertisements.Principal.length);
      this.services.postAdvertisementUser(this.advertisements.getAllRelAdsMetricsIdDisplayed());
    }
  }

  backClicked() {
    this._location.back();
  }

  async getInfoUser() {
    // console.log("Antes de loading... ",this.viewShowImag);
    const loading = await this.loadingController.create({
      message: 'Cargando usuario...',
      duration: 3000,
    });
    loading.present();
    // console.log("Despues de loading... ",this.viewShowImag);
    (await this.services.userUpdate()).subscribe(
      async (data) => {
        this.userData = await data;
        if (this.userData.imageUrl !== 'https://test-bucket-72bc5c3f-5c53-4442-9610-58d5c984afb1.s3.amazonaws.com/Users/userDefault.jpg') {
          this.viewShowImag = this.userData.imageUrl;
          // console.log("Despues de Cargar... ",this.viewShowImag);
        }
        loading.dismiss();
      },
      (error) => {
        // console.log(error);
        loading.dismiss();
      }
    );
  }
  async loadImageFromDevice(event) {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = async () => {
      // get the blob of the image:
      let blob: Blob = new Blob([new Uint8Array((reader.result as ArrayBuffer))]);
      event.target.files = null;
      const formData = new FormData();
      const idUser = localStorage.getItem("idUser");
      formData.append('file', blob, 'imagen.jpg');
      await this.uploadImageData(formData, idUser);
    };
    reader.onerror = (error) => {

    };
  };
  async getCatJobs() {
    (await this.services.getCatJobs()).subscribe(
      (data) => {
        this.catJobs = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  async getCatForums() {
    (await this.services.getCatForums()).subscribe(
      (data) => {
        this.catForums = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  async getCatMachines() {
    (await this.services.getCatMachines()).subscribe(
      (data) => {
        this.catMachines = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  // Upload user image
  async updateImage() {
    await this.selectImage();
  }

  async saveInfoUser() {
    let message:string = '';
    if(!this.userData.name){
      message = "Falta llenar el campo 'Nombre'";
    }else if(!this.userData.lastName){
      message = "Falta llenar el campo 'Apellido paterno'";
    }else if(!this.userData.secondLastName){
      message = "Falta llenar el campo 'Apellido materno'";
    }else if(!this.userData.username){
      message = "Falta llenar el campo 'Nombre de usuario'";
    }else if(!this.userData.genderId){
      message = "Falta seleccionar Género";
    }else if(!this.userData.birthdate){
      message = "Falta llenar el campo 'Fecha de nacimiento'";
    }else if(!this.userData.stateId){
      message = "Falta seleccionar un estado";
    }else if(!this.userData.workPlace){
      message = "Si no trabajas en ninguna empresa, escribe alguna de estas opciones: <b>Estudiante, Trabajador independiente, otro.</b>";
    }else if(!this.userData.phoneNumber){
      message = "Falta llenar el campo 'Número de teléfono";
    }else if(!this.userData.jobId){
      message = "Seleccione un puesto/cargo";
    }else if(!this.userData.relUsersMachinesData){
      message = "Seleccione algún tipo de máquina que utilices";
    }else if(!this.userData.relUsersInterestsData){
      message = "Seleccione algún interés";
    }
    if(message){
      const alert = await this.alertController.create({
        header: "Complete campo faltante",
        subHeader: "",
        message: message,
        buttons: ["OK"],
      });
      await alert.present();
      return;
    }
    
    this.services.saveInfoUserService(this.userData).subscribe(
      async (data) => {
        // const alert = await this.alertController.create({
        //   message: 'Usuario actualizado'
        // });
        // await alert.present();
        // await alert.onDidDismiss();
        // await this.getInfoUser();
        if(this.isValidToInsertPointBadge()){
          this.insertPointBadge();
          return;
        }
        this.router.navigate(['/bienvenido']);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  async presentConfirm() {
    const alert = await this.alertController.create({
      message: 'Si desactiva el usuario, ya no podra acceder a la app.\n¿Desea inactivar usuario?',
      buttons: [
        {
          text: 'No',
          handler: () => {
            alert.dismiss();
          }
        },
        {
          text: 'Si',
          handler:async () => {
            await this.desactivarUsuario();
          }
        }
      ]
    });
    await alert.present();
  }
  async desactivarUsuario() {
    let loading = await this.loadingController.create({
      message: 'Procesando...'
     });
     await loading.present();

    this.services.desactivarUsuarioService(this.userData).subscribe(
      async (data) => {
        console.log(data);
        let result = await data;
        if(result['susseful'] === 1)
        {
          await loading.dismiss();
          const alert = await this.alertController.create({
            message:result['mensaje'],
            buttons: [
              {
                text: 'Ok',
                handler: () => {
                  localStorage.clear();
                  this.utils.isLogged = false;
                  this.router.navigate(['/home']);
                }
              }
            ]
          });
          await alert.present();
        }
        
      },
      async (error) => {
        console.log(error);
        loading.dismiss();
            let mensage = "Por favor intenta de Nuevo";
              switch(error.status){
                case 404:
                case 400:
                case 403:
                case 401:
                case 500:
                  mensage = error.error;
                  break;
              }
              const alert = await this.alertController.create({
                header: "Error de aplicacion",
                subHeader: "",
                message: mensage,
                buttons: ["OK"],
              });
              await alert.present();
      }
    );
  }
  // Secction upload image
  async selectImage() {
    const actionSheet = await this.actionSheetController.create({
      header: 'Seleccionar fuente de imagen',
      buttons: [
        {
          text: 'Cargar desde Galeria',
          handler: () => {
            this.takePicture(this.camera.PictureSourceType.PHOTOLIBRARY);
          },
        },
        {
          text: 'Usar Camara',
          handler: () => {
            this.takePicture(this.camera.PictureSourceType.CAMERA);
          },
        },
        {
          text: 'Cancelar',
          role: 'cancel',
        },
      ],
    });
    await actionSheet.present();
  }
  cropImage(fileUrl,sourceTypes) {
    this.crop.crop(fileUrl, { quality: 50 })
      .then(
        newPath => {
          this.showCroppedImage(newPath,sourceTypes)
        },
        error => {
          alert('Error cropping image' + error);
        }
      );
  }
  async showCroppedImage(imagePath,sourceTypes) {
    /*if (
      this.platform.is('android') &&
      sourceTypes === this.camera.PictureSourceType.PHOTOLIBRARY
    ) {
      this.filePath.resolveNativePath(imagePath).then(async (filePath) => {
        // tslint:disable-next-line: no-shadowed-variable
        const correctPath = filePath.substr(0, filePath.lastIndexOf('/') + 1);
        // tslint:disable-next-line: no-shadowed-variable
        const currentName = imagePath.substring(
          imagePath.lastIndexOf('/') + 1,
          imagePath.lastIndexOf('?')
        );
        await this.copyFileToLocalDir(
          correctPath,
          currentName,
          this.createFileName()
        );
        await this.startUpload(this.image);
      });
    } else {
      const currentName = imagePath.substr(imagePath.lastIndexOf('/') + 1);
      const correctPath = imagePath.substr(0, imagePath.lastIndexOf('/') + 1);
      await this.copyFileToLocalDir(
        correctPath,
        currentName,
        this.createFileName()
      );
      await this.startUpload(this.image);
      //await this.getInfoUser();
    }*/
    this.filePath.resolveNativePath(imagePath).then(async (filePath) => {
      // tslint:disable-next-line: no-shadowed-variable
      const correctPath = filePath.substr(0, filePath.lastIndexOf('/') + 1);
      // tslint:disable-next-line: no-shadowed-variable
      const currentName = imagePath.substring(
        imagePath.lastIndexOf('/') + 1,
        imagePath.lastIndexOf('?')
      );
      await this.copyFileToLocalDir(
        correctPath,
        currentName,
        this.createFileName()
      );
      await this.startUpload(this.image);
    });
  }
  async takePicture(sourceTypes: PictureSourceType) {
    const options: CameraOptions = {
      quality: 100,
      sourceType: sourceTypes,
      saveToPhotoAlbum: false,
      correctOrientation: true,
      destinationType: this.camera.DestinationType.FILE_URI
    };

    await this.camera.getPicture(options).then(async (imagePath) => {
      this.viewShowImag = `data:image/jpeg;base64,${imagePath}`;
      await this.cropImage(imagePath,sourceTypes);
    });
  }
  async copyFileToLocalDir(namePath, currentName, newFileName) {
    await this.file
      .copyFile(namePath, currentName, this.file.dataDirectory, newFileName)
      .then(
        async (success) => {
          await this.uploadImage(newFileName);
        },
        (error) => {
          this.presentToast('Error while storing file.');
        }
      );
  }
  async uploadImage(name) {
    const filePath = (await this.file.dataDirectory) + name;
    const resPath = await this.pathForImage(filePath);

    const newEntry = {
      name: name,
      path: resPath,
      filePath: filePath
    };
    console.log('imagen nueva:', newEntry);
    this.image = newEntry;
    await this.ref.detectChanges(); // trigger change detection cycle
  }
  createFileName() {
    // tslint:disable-next-line: one-variable-per-declaration
    const d = new Date(),
      n = d.getTime(),
      newFileName = n + '.jpg';
    return newFileName;
  }
  async presentAlert(mensaje, cabezera) {
    const alert = await this.alertController.create({
      header: cabezera,
      message: mensaje,
      buttons: ['OK'],
    });
  }
  async presentToast(text) {
    const toast = await this.toastController.create({
      message: text,
      position: 'bottom',
      duration: 3000,
    });
    toast.present();
  }
  async pathForImage(img) {
    if (img === null) {
      return '';
    } else {
      const converted = await this.webview.convertFileSrc(img);
      return converted;
    }
  }
  async startUpload(imgEntry) {
    await this.file
      .resolveLocalFilesystemUrl(imgEntry.filePath)
      .then(async (entry) => {
        (entry as FileEntry).file(async (file) => await this.readFile(file));
      })
      .catch((err) => {
        this.presentToast('Error while reading file.');
      });
  }

  async readFile(file: any) {
    const reader = new FileReader();
    reader.onload = async () => {
      const formData = new FormData();
      const imgBlob = await new Blob([reader.result], { type: 'image/jpeg' });
      const idUser = localStorage.getItem("idUser");

      formData.append('file', imgBlob, 'imagen.jpg');
      await this.uploadImageData(formData, idUser);
    };
    
    reader.readAsArrayBuffer(file);
  }

  async uploadImageData(formData, id) {
    const token = localStorage.getItem("token");

    const loading = await this.loadingController.create({
      message: 'Subiendo imagen...'
    });

    await loading.present();

    const options = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    
    const url = await this.services.getUrlPutImagen();
    await this.http.put(url + id, formData, options).subscribe(async (res) => {
      await loading.dismiss();
      if(this.isValidToInsertPointBadge()){
        this.insertPointBadge();
        return;
      }
      this.services.redirectHome();
    });
  }

  isValidToInsertPointBadge(){
    let PointEarnedUser:PointEarnedUser = JSON.parse(localStorage.getItem("PointEarnedUser"));
    // si ya tiene el primer badge no insertar
    let havingPointEarnedUser = PointEarnedUser?.relUsersBadges?.some((badge:RelUserBadges)=>badge.catBadgeId==1);
    if(havingPointEarnedUser){
      return false;
    }

    // si no checamos que tenga toda la info
    if(
      this.viewShowImag !== '../../assets/images/userDefault.jpg' 
      && this.viewShowImag !== 'https://test-bucket-72bc5c3f-5c53-4442-9610-58d5c984afb1.s3.amazonaws.com/Users/userDefault.jpg'
      && this.userData?.birthdate 
      && this.userData?.genderId 
      && this.userData?.jobId 
      && this.userData?.lastName 
      && this.userData?.name 
      && this.userData?.stateId 
      && this.userData?.username
    ){
      return true;
    }
    return false;
  }

  async insertPointBadge(){
    let addPointsBadges = {
      IdBadge: 1
    };
    (await this.services.addPointsBadges(addPointsBadges)).subscribe(
      (data:any)=>{
        this.showAlert();
      },
      (error)=>{
        if(error.status==200){
          this.showAlert();
          return;
        }
      }
    )
  }

  async showAlert(){
    const alert = await this.alertController.create({
      message: 'Obtuvo la medalla: Buen Look! + 10 puntos.'
    });
    await alert.present();
    this.services.redirectHome();
  }

  onKeypressEvent(event: any){
      // console.log(event.target.value);
      var charCode = (event.which) ? event.which : event.keyCode

      if (charCode > 31 && (charCode < 48 || charCode > 57))
      return false;

      return true;
  }

  checkData($event){
  
    let regex = /^([0-9]+)$/g; 
    let key = $event.detail.value;
    
    if(!regex.test(key) && key != ""){
      let newVal = String(key).replace(/[^\d]/g, '');
      $event.target.value = newVal;
      this.userData.phoneNumber = newVal;
  
    }
    
  }
}

export class UserUpdate {
  constructor(
    public id?: number,
    public name?: string,
    public lastName?: string,
    public secondLastName?: string,
    public imageUrl?: string,
    public genderId?: number,
    public stateId?: number,
    public birthdate?: string,
    public state?: string,
    public username?: string,
    public email?: string,
    public jobId?: number,
    public hitecUser?: number,
    public relUsersInterestsData?: number[],
    public relUsersMachinesData?: number[],
    public workPlace?: string,
    public phoneNumber?: string
  ) { }
}

export class CatJob {
  constructor(
    public id?: number,
    public job?: string,
  ) { }
}

export class CatForum {
  constructor(
    public id?: number,
    public forum?: string,
  ) { }
}

export class CatMachine {
  constructor(
    public id?: number,
    public machine?: string,
  ) { }
}